import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["target", "href", "class"];
import React from 'react';
import { isInternalLink } from './MarkdownLink.utils';
import InternalLink from '../../../../atoms/InternalLink/InternalLink';
import OutboundLink from '../../../../atoms/OutboundLink/OutboundLink';
var defaultProps = {
  target: '',
  "class": ''
};
export default function MarkdownLink(_ref) {
  var target = _ref.target,
    href = _ref.href,
    className = _ref["class"],
    rest = _objectWithoutProperties(_ref, _excluded);
  if (isInternalLink({
    href: href
  })) {
    return /*#__PURE__*/React.createElement(InternalLink, _extends({}, rest, {
      to: href,
      className: className
    }));
  }
  return /*#__PURE__*/React.createElement(OutboundLink, _extends({}, rest, {
    to: href,
    className: className,
    newTab: target === '_blank'
  }));
}
MarkdownLink.defaultProps = defaultProps;